import React, { Ref } from 'react'

function _IconComparison(props: React.SVGProps<SVGSVGElement>, ref?: Ref<SVGSVGElement>) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={ref}
    >
      <g clipPath="url(#clip0_4323_180285)">
        <path
          d="M14 3H9V2C9 1.73478 8.89464 1.48043 8.70711 1.29289C8.51957 1.10536 8.26522 1 8 1H2C1.73478 1 1.48043 1.10536 1.29289 1.29289C1.10536 1.48043 1 1.73478 1 2V12C1 12.2652 1.10536 12.5196 1.29289 12.7071C1.48043 12.8946 1.73478 13 2 13H7V14C7 14.2652 7.10536 14.5196 7.29289 14.7071C7.48043 14.8946 7.73478 15 8 15H14C14.2652 15 14.5196 14.8946 14.7071 14.7071C14.8946 14.5196 15 14.2652 15 14V4C15 3.73478 14.8946 3.48043 14.7071 3.29289C14.5196 3.10536 14.2652 3 14 3ZM2 7.5H5.085L3.795 8.795L4.5 9.5L7 7L4.5 4.5L3.795 5.205L5.085 6.5H2V2H8V12H2V7.5ZM8 14V13C8.26522 13 8.51957 12.8946 8.70711 12.7071C8.89464 12.5196 9 12.2652 9 12V4H14V8.5H10.915L12.205 7.205L11.5 6.5L9 9L11.5 11.5L12.205 10.795L10.915 9.5H14V14H8Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_4323_180285">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const IconComparison = React.forwardRef(_IconComparison)
